<template>
    <div></div>
</template>
<script>
import { getUserProfile } from '@/libs/api/api'

export default {
    beforeRouteEnter (to, from, next) {
        getUserProfile({})
            .then((response)=> {
                if (response && response.id) {
                    next({name: `users-overview`, params: {id: response.id}})
                }
            })
            .catch(()=> {})
    },
}
</script>